import { getSoftpullResponse } from '../middleware/getSoftpullResponse'
import { goToSavedChatLink } from '../default/goToSavedChatLink'
import { getSessionValue } from '../default/getSessionValue'
import { gtagsConversion } from '../pixels/gtags'

/**
 * Submit softpull as second request after form-submit, auto cancels after 10s
 * @param {object} softPullPayload
 * @param {string} savedChatLink
 * @param {string} savedThanksUrl
 * @param {string} SESSION_ID
 */

export async function submitSoftpull(
  softPullPayload,
  savedChatLink,
  savedThanksUrl,
  SESSION_ID,
) {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 15000) // cancel after 15s
  const redirectTimeoutId = setTimeout(() => {
    window.location.href = 'https://www.turbodebt.com/chat/'
  }, 20000)

  try {
    const data = await getSoftpullResponse(softPullPayload, {
      signal: controller.signal,
    })

    if (data.success) {
      // clear timeouts if request finishes in time and is successful
      clearTimeout(timeoutId)
      clearTimeout(redirectTimeoutId)
    }

    if (!data) {
      console.warn('softpull unsuccessful')
      goToSavedChatLink(savedChatLink)
      return
    }

    const { updated_url, isDelinquent } = data

    if (updated_url && updated_url !== '') {
      if (
        updated_url.includes('offerwall') &&
        getSessionValue(SESSION_ID, 'utm_campaign') === '918'
      ) {
        const sub1 = getSessionValue(SESSION_ID, 'sub1')
        const url = new URL(updated_url)
        url.searchParams.set('c1', 'eranwes')
        if (sub1) {
          url.searchParams.set('sub1', sub1)
        }
        window.location.href = url.toString()
        return
      }
      window.location.href = updated_url
      return
    }

    if (isDelinquent === false) {
      // internal
      if (getSessionValue(SESSION_ID, 'utm_campaign') === '918') {
        await gtagsConversion('G-MC0PZ596KV', {
          send_to: 'AW-11424527567/0HiJCMiNoZYZEM_p0ccq',
        })
      }
    }

    window.location.href = savedThanksUrl
  } catch (e) {
    if (e instanceof DOMException && e.name === 'AbortError') {
      console.error('softpull request timed out')
    } else {
      console.error('error with softpull endpoint:', e)
    }
    goToSavedChatLink(savedChatLink)
  } finally {
    localStorage.removeItem('TD_CACHE')
  }
}
